import { getIsInFlowsItem } from "../../reducers/session";

import classNames from "classnames";
import React, { useState } from "react";
import { IAppState } from "../../types/stores";
import { useSelector } from "react-redux";

import Filter from "./Filter";
import languageShape from "./shapes/languageShape";
import arrayFrom from "./util/arrayFrom";
import capitalizeFirstLetter from "./util/capitalizeFirstLetter";

import Paper from "@material-ui/core/Paper";

type Props = {
    canFilter: boolean;
    children: any;
    controlKey: string;
    disabled: boolean;
    filterPlaceholder: string;
    filterValue: string;
    id: string;
    inputRef: any;
    lang: languageShape;
    showHeaderLabels: boolean;
    showNoOptionsText: boolean;
    onDoubleClick: any;
    onFilterChange: any;
    onKeyUp: any;
    actions: any;
};

const ListBox: React.FC<Props> = ({
    canFilter,
    children,
    controlKey,
    disabled,
    filterPlaceholder,
    filterValue,
    id,
    inputRef,
    lang,
    showHeaderLabels,
    showNoOptionsText,
    onDoubleClick,
    onFilterChange,
    onKeyUp,
    actions,
}: Props) => {
    const [value, setValue] = useState([]);
    const isInFlowsItem = useSelector((state: IAppState) => getIsInFlowsItem(state));

    /**
     * @param {object} event
     *
     * @returns {void}
     */
    const onChange = (event: any) => {
        const val = arrayFrom(event.target.options)
            .filter(option => option.selected)
            .map(option => option.value);

        setValue(val);
    };

    /**
     * @returns {React.Component}
     */
    const renderFilter = () => {
        if (!canFilter) {
            return null;
        }

        return (
            <Filter
                controlKey={controlKey}
                filterPlaceholder={filterPlaceholder}
                filterValue={filterValue}
                id={id}
                lang={lang}
                onFilterChange={onFilterChange}
            />
        );
    };

    /**
     * @returns {React.Component}
     */
    const renderSelect = () => {
        if (showNoOptionsText && React.Children.count(children) === 0) {
            return <div className="rdl-no-options">{lang[`no${capitalizeFirstLetter(controlKey)}Options`]}</div>;
        }

        let listSelect = (
            <select
                className={`rdl-control rdl-control-${controlKey}`}
                disabled={disabled}
                id={`${id}-${controlKey}`}
                multiple
                ref={inputRef}
                value={value}
                onChange={onChange}
                onDoubleClick={onDoubleClick}
                onKeyUp={onKeyUp}
            >
                {children}
            </select>
        );

        if (isInFlowsItem) {
            listSelect = (
                <Paper>
                    <select
                        className={`rdl-control rdl-control-${controlKey}`}
                        disabled={disabled}
                        id={`${id}-${controlKey}`}
                        multiple
                        ref={inputRef}
                        value={value}
                        onChange={onChange}
                        onDoubleClick={onDoubleClick}
                        onKeyUp={onKeyUp}
                    >
                        {children}
                    </select>
                </Paper>
            );
        }

        return (
            <div className="rdl-control-container">
                {actions}
                {listSelect}
            </div>
        );
    };
    const labelClassName = classNames({
        "rdl-control-label": true,
        "rdl-sr-only": !showHeaderLabels,
    });

    return (
        <div className={`rdl-list-box rdl-${controlKey}`}>
            <label className={labelClassName} htmlFor={`${id}-${controlKey}`}>
                {lang[`${controlKey}Header`]}
            </label>
            {renderFilter()}
            {renderSelect()}
        </div>
    );
};

export default ListBox;
